__turbopack_context__.v({
  "active": "Header-module__zyU3Tq__active",
  "asideItem": "Header-module__zyU3Tq__asideItem",
  "closeSearch": "Header-module__zyU3Tq__closeSearch",
  "colLeft": "Header-module__zyU3Tq__colLeft",
  "colRight": "Header-module__zyU3Tq__colRight",
  "counter": "Header-module__zyU3Tq__counter",
  "desktopOnly": "Header-module__zyU3Tq__desktopOnly",
  "faves": "Header-module__zyU3Tq__faves",
  "focused": "Header-module__zyU3Tq__focused",
  "header": "Header-module__zyU3Tq__header",
  "headerInner": "Header-module__zyU3Tq__headerInner",
  "horizontalNavOnly": "Header-module__zyU3Tq__horizontalNavOnly",
  "isBurgerOpen": "Header-module__zyU3Tq__isBurgerOpen",
  "item": "Header-module__zyU3Tq__item",
  "langWrapper": "Header-module__zyU3Tq__langWrapper",
  "logo": "Header-module__zyU3Tq__logo",
  "navWrapper": "Header-module__zyU3Tq__navWrapper",
  "notHorizontalNav": "Header-module__zyU3Tq__notHorizontalNav",
  "searchWrapper": "Header-module__zyU3Tq__searchWrapper",
});
